import React from 'react'

const index = () => {
  return (
    <div>
        DshboardContent
    </div>
  )
}

export default index